export default import.meta.ROLLDOWN_FILE_URL_0uM9SUt0QC$A3bohcTHDOg